<template>
	<div>
		<!-- <el-button  v-if="item.authority===undefined?true:authority[item.authority]"  @click.stop="click(item)" v-for="(item,key) in param.buttons" :key="key" :size="size">{{item.txt}}</el-button> -->
		<el-button v-if="pan(item)" style="height: 28px;" v-show="ishow[key]" @click.stop="click(item)" v-for="(item,key) in param.buttons"
		 :key="setState(item,key)" :size="size">{{item.txt}}</el-button>
	</div>
</template>

<script>
	//该页面为list页面不受权限控制的其他操作
	export default {
		data() {
			return {
				size: 'small',
				locked: true,
				ishow: [true, true, true, true, true, true],
			}
		},
		props: {
			param: {
				type: Object,
				default: {}
			},
			row: {
				type: Object,
				default: {}
			},
			unlock: {
				type: Boolean,
				defualt: true
			},
			authority: {
				type: Object,
				default: {}
			},
			childrenCom: ''
		},
		watch: {
			unlock(a, b) {
				this.locked = true
			}
		},
		created: function() {
			if (this.$route.path == '/ResignationEmployee') {
				if (!this.row.is_findpower) {
					for (let i = 0; i < this.param.buttons.length; i++) {
						if (this.param.buttons[i].txt == '查看') {
							this.param.buttons.splice(i, 1)
						}
					}
				}
			}
		},
		methods: {
			click(item) {
				item.fn(item, this.row)
			},
			setState(item, key) {
				if (item.borrow) {
					if (this.locked) {
						this.locked = false
						let authority = item.authority === undefined ? true : this.authority[item.authority]
						let arr = []
						arr[0] = authority
						if ((/借出/g.test(this.row.GoseString)) && (/审核通过/g.test(this.row.StateName))) {
							arr[1] = authority
						} else {
							arr[1] = false
						}
						if ((/预借中/g.test(this.row.GoseString)) && (/审核通过/g.test(this.row.StateName))) {
							arr[2] = authority
						} else {
							arr[2] = false
						}

						this.ishow = arr
						return key
					}
				}
			},
			pan(item) {
				if (this.$route.path == '/personCertificateEdit'||this.$route.path == '/personCertificateAdd') {
					if (item.txt == '选定') {
						return true
					} else {
						return this.row.is_findpower
					}
				}else if(this.$route.path == '/BorrowCertificate'){
					return true
				}else{
					return this.authority[item.authority]
				}
				
			}
		}
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/sub/listCaoZuoO.vue